import { StateCreator } from 'zustand'
import { OrgType } from 'app/dataTypes/org/types'
import { FilterValues, DefaultsSlice, FilterStore } from './types'
import { calcDefaultPeriod } from './defaultPeriod'

const emptyDefaults: FilterValues = {
  orgType: OrgType.School,
  orgIds: undefined,
  buildingIds: undefined,
  schoolYearId: undefined,
  period: calcDefaultPeriod(),
  saleTypeIds: undefined,
  foodModeIds: undefined,
  customerTypeIds: undefined,
  salePointIds: undefined,
  employeeIds: undefined,
  mail: 'do_not_mail',
  // ADD HERE
}

export const createDefaultsSlice: StateCreator<FilterStore, [], [], DefaultsSlice> = (set) => ({
  defaults: emptyDefaults,

  setDefaults(values) {
    set((state) => ({
      defaults: {
        ...state.defaults,
        ...values,
      },
    }))
  },
})
